import React from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Brands from "@/components/site/Brands";
import Services from "@/components/site/Services";
import Products from "@/components/site/Products";
import Process from "@/components/site/Process";
import ResearchLab from "@/components/site/ResearchLab";
import Capacity from "@/components/site/Capacity";
import International from "@/components/site/International";
import Quality from "@/components/site/Quality";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white text-[#0A1628]" data-testid="landing-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Brands />
        <Services />
        <Quality />
        <Products />
        <Capacity />
        <Process />
        <International />
        <ResearchLab />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
